"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandingPose = void 0;
var Blazer1V2_1 = require("./Blazer1V2");
var Blazer2V2_1 = require("./Blazer2V2");
var Blazer3V2_1 = require("./Blazer3V2");
var Blazer4V2_1 = require("./Blazer4V2");
var Crossedarms1V2_1 = require("./Crossedarms1V2");
var Crossedarms2V2_1 = require("./Crossedarms2V2");
var Doctornurse01V2_1 = require("./Doctornurse01V2");
var Doctornurse02V2_1 = require("./Doctornurse02V2");
var Doctornurse03V2_1 = require("./Doctornurse03V2");
var Easing1V2_1 = require("./Easing1V2");
var Easing2V2_1 = require("./Easing2V2");
var Pointingfinger1V2_1 = require("./Pointingfinger1V2");
var Pointingfinger2V2_1 = require("./Pointingfinger2V2");
var PolkadotsV2_1 = require("./PolkadotsV2");
var Resting1V2_1 = require("./Resting1V2");
var Resting2V2_1 = require("./Resting2V2");
var Robotdance1V2_1 = require("./Robotdance1V2");
var Robotdance2V2_1 = require("./Robotdance2V2");
var Robotdance3V2_1 = require("./Robotdance3V2");
var Shirt1V2_1 = require("./Shirt1V2");
var Shirt2V2_1 = require("./Shirt2V2");
var Shirt3V2_1 = require("./Shirt3V2");
var Shirt4V2_1 = require("./Shirt4V2");
var Walking1V2_1 = require("./Walking1V2");
var Walking2V2_1 = require("./Walking2V2");
var Walking3V2_1 = require("./Walking3V2");
exports.StandingPose = {
    Blazer1V2: Blazer1V2_1.Blazer1V2,
    Blazer2V2: Blazer2V2_1.Blazer2V2,
    Blazer3V2: Blazer3V2_1.Blazer3V2,
    Blazer4V2: Blazer4V2_1.Blazer4V2,
    Crossedarms1V2: Crossedarms1V2_1.Crossedarms1V2,
    Crossedarms2V2: Crossedarms2V2_1.Crossedarms2V2,
    Doctornurse01V2: Doctornurse01V2_1.Doctornurse01V2,
    Doctornurse02V2: Doctornurse02V2_1.Doctornurse02V2,
    Doctornurse03V2: Doctornurse03V2_1.Doctornurse03V2,
    Easing1V2: Easing1V2_1.Easing1V2,
    Easing2V2: Easing2V2_1.Easing2V2,
    Pointingfinger1V2: Pointingfinger1V2_1.Pointingfinger1V2,
    Pointingfinger2V2: Pointingfinger2V2_1.Pointingfinger2V2,
    PolkadotsV2: PolkadotsV2_1.PolkadotsV2,
    Resting1V2: Resting1V2_1.Resting1V2,
    Resting2V2: Resting2V2_1.Resting2V2,
    Robotdance1V2: Robotdance1V2_1.Robotdance1V2,
    Robotdance2V2: Robotdance2V2_1.Robotdance2V2,
    Robotdance3V2: Robotdance3V2_1.Robotdance3V2,
    Shirt1V2: Shirt1V2_1.Shirt1V2,
    Shirt2V2: Shirt2V2_1.Shirt2V2,
    Shirt3V2: Shirt3V2_1.Shirt3V2,
    Shirt4V2: Shirt4V2_1.Shirt4V2,
    Walking1V2: Walking1V2_1.Walking1V2,
    Walking2V2: Walking2V2_1.Walking2V2,
    Walking3V2: Walking3V2_1.Walking3V2
};
